import { Trans } from '@lingui/macro';
import { AUTO_COMPLETE_DEFAULT } from '../../../../../../utilities/FormUtilities';
import NgpTextField from '../../../../../form/NgpTextField';
import TestFormSection from '../TestFormSection/TestFormSection';

export const VoipPhoneNumberToCallSection = () => {
    return (
        <TestFormSection title={<Trans>Phone Number to Call</Trans>}>
            <NgpTextField
                fieldName={'testConfig.phone'}
                label={<Trans>Phone Number</Trans>}
                required
                inputProps={{
                    size: 64,
                    maxLength: 192,
                    autoComplete: AUTO_COMPLETE_DEFAULT,
                }}
            />
        </TestFormSection>
    );
};
